import { render, staticRenderFns } from "./PortfolioHoldingsAreaContainer.vue?vue&type=template&id=1ccbcd91&scoped=true&"
import script from "./PortfolioHoldingsAreaContainer.vue?vue&type=script&lang=js&"
export * from "./PortfolioHoldingsAreaContainer.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHoldingsAreaContainer.vue?vue&type=style&index=0&id=1ccbcd91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbcd91",
  null
  
)

export default component.exports